import React, { useEffect } from 'react'
import { useDispatch } from "react-redux";

import { setWebsiteLanguage } from "../../redux/content";
import italian_language from "../../assets/site_material/icons/it.png";
import english_language from "../../assets/site_material/icons/uk.png";



const LanguagesToolbar = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        document.getElementById('english-language').style['border-bottom'] = "5px solid #fba919"
    }, [])
    


    const setLanguage = (e, language) => {
        e.preventDefault()
        e.currentTarget.border = "5px solid #fba919"
       
        if (e.currentTarget.id === 'english-language') {
            e.currentTarget.style['border-bottom'] = "5px solid #fba919"
            document.getElementById('italian-language').style['border-bottom'] = ""
        } else {
            e.currentTarget.style['border-bottom'] = "5px solid #fba919"
            document.getElementById('english-language').style['border-bottom'] = ""
        }

        return dispatch(setWebsiteLanguage(language))
    }
    return (
        <div className="languages-toolbar">
            <div id="english-language" onClick={(e) => setLanguage(e, 'english')}> 
                <img
                    alt="English"
                    src={english_language}
                />
            </div>
            <div id="italian-language" onClick={(e) => setLanguage(e, 'italian')}>
                <img
                    alt="Italian"
                    src={italian_language}
                />
            </div>
        </div>

    )
}

export default LanguagesToolbar